import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ElementMarker33ojvsajwmzts as ElementMarker } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/ElementMarker.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readIfAbsent($this, descriptor, index) {
  $this.e2r_1 = (!descriptor.q1p(index) && descriptor.p1p(index).b1p());
  return $this.e2r_1;
}
function JsonElementMarker$readIfAbsent$ref(p0) {
  var l = (_this__u8e3s4, p0_0) => {
    var tmp0 = p0;
    return readIfAbsent(tmp0, _this__u8e3s4, p0_0);
  };
  l.callableName = 'readIfAbsent';
  return l;
}
var JsonElementMarkerClass;
function JsonElementMarker() {
  if (JsonElementMarkerClass === VOID) {
    class $ {
      constructor(descriptor) {
        var tmp = this;
        tmp.d2r_1 = new (ElementMarker())(descriptor, JsonElementMarker$readIfAbsent$ref(this));
        this.e2r_1 = false;
      }
      f2r(index) {
        this.d2r_1.m1x(index);
      }
      g2r() {
        return this.d2r_1.n1x();
      }
    }
    initMetadataForClass($, 'JsonElementMarker');
    JsonElementMarkerClass = $;
  }
  return JsonElementMarkerClass;
}
//region block: exports
export {
  JsonElementMarker as JsonElementMarker395jk2pil4789,
};
//endregion

//# sourceMappingURL=JsonElementMarker.mjs.map
